import type { SVGProps } from 'react';
const SvgAspectRatio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#aspect_ratio_svg__a)">
      <path
        fill="currentColor"
        d="M19 12h-2v3h-3v2h5v-5ZM7 9h3V7H5v5h2V9Zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16.01H3V4.99h18v14.02Z"
      />
    </g>
    <defs>
      <clipPath id="aspect_ratio_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAspectRatio;
